import IsMunicipalityMixin from '@/mixins/isMunicipalityCheck';
import {log} from "util";

const mixin = {
  filterNav: [
    {
      text: 'Каталог',
      variant: 'catalog',
      to: {
        name: 'events',
      },
    },
    {
      text: 'Карта',
      variant: 'map',
      to: {
        name: 'map',
      },
    },
  ],

  mixins: [IsMunicipalityMixin],

  computed: {
    filterValues() {
      let result = {};
      this.filterFields.forEach(({ code, getDefault }) => {
        const execDef =
          this[code] === undefined && typeof getDefault === 'function';
        result[code] = execDef ? getDefault.call(this) : this[code];
      });
      return result;
    },

    filterFields() {
      const {
        industries,
        competences,
        professions,
        educationForm,
        municipalities,
        educationCategories,
      } = this.$store.state;
      const { isMunicipality } = this;

      // тут главная

      const MUNICIPALITY_EMPTY = '';
      let municipalityFilter = {};

      if (isMunicipality) {
        municipalityFilter.filter = (list, current) =>
          list.filter(
            (item) =>
              item.default ||
              item.municipality_id ==
                (current.municipality || MUNICIPALITY_EMPTY),
          );
      }

      const municipalityFields = isMunicipality
        ? [
            {
              title: 'Место обучения',
              placeholder: 'Место обучения',
              code: 'municipality',
              data: [{ name: 'Не выбрано', id: '' }, ...municipalities],
              filterable: 'auto',
            },
          ]
        : [];

      const industryFields = [
        {
          title: 'Отрасль',
          code: 'industry',
          data: [
            {
              name: 'Не выбрано',
              id: '',
            },
            ...industries,
          ],
          filterable: 'auto',
        },

        {
          title: 'Профессия',
          code: 'profession',
          data: [
            {
              name: 'Не выбрано',
              id: '',
              default: true,
            },
            ...professions,
          ],
          filter(list, current) {
            return list.filter(
              (item) =>
                item.default ||
                !current.industry ||
                item.industries.includes(current.industry),
            );
          },
          filterable: 'auto',
        },

        // {
        //   title: 'Компетенции',
        //   code: 'competence',
        //   data: [
        //     {
        //       name: 'Не выбрано',
        //       id: '',
        //       default: true,
        //     },
        //     ...competences,
        //   ],
        //   filter(list, current) {
        //     return list.filter(
        //       (item) =>
        //         item.default ||
        //         !current.industry ||
        //         item.industries.includes(current.industry),
        //     );
        //   },
        //   filterable: 'auto',
        // },
      ];

      const categoryField = [
        {
          title: 'Категория обучающихся',
          code: 'cat_edu',
          data: [
            { name: 'Не выбрано', id: '', default: true },
            ...educationCategories,
          ],
          filterable: 'auto',
        },
      ];

      const modeField = [
        {
          title: 'Форма обучения',
          code: 'form_education',
          data: [
            { name: 'Не выбрано', id: '', default: true },
            ...educationForm,
          ],
          filterable: 'auto',
        },
      ];

      const ovzField = [
        {
          title: 'Адаптация для лиц с ОВЗ',
          code: 'is_ovz',
          data: [
            { name: 'Не выбрано', id: '' },
            { name: 'Да', id: '1' },
            { name: 'Нет', id: '0' },
          ],
        },
      ];

      const freeField = [
        {
          title: 'Бесплатно',
          code: 'is_free',
          data: [
            { name: 'Не выбрано', id: '' },
            { name: 'Да', id: '1' },
            { name: 'Нет', id: '0' },
          ],
        },
      ];

      return [
        ...categoryField,
        ...industryFields,
        ...modeField,
        ...municipalityFields,
        ...ovzField,
        ...freeField,
      ];
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/mixin-filter.js